import { defineMessages } from 'react-intl-next';

export const messages: {
	searchButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchButtonLabel: {
		id: 'csm.chat.widget.search.trigger.search.button.label.non-fin',
		defaultMessage: 'Search with AI',
		description: 'label for the CSM chat widget search trigger button',
	},
});
